import React from 'react';
import { WrappedFieldProps } from 'redux-form';

import {
    FieldProps,
    FieldWrapperProps,
    InputFieldWrapper,
} from 'app/components/common/inputs/common/input/input-field-wrapper';

interface OwnProps<T> {
    component: React.ComponentType<T>;
}

export type FormFieldWrapperProps<T extends FieldProps> = WrappedFieldProps & FieldWrapperProps<T>;

type Props<T extends FieldProps> = FormFieldWrapperProps<T> & OwnProps<T>;

class FormInputFieldWrapper<T extends FieldProps> extends React.Component<Props<T>> {
    public render(): React.ReactNode {
        const { meta, ...rest } = this.props;

        return <InputFieldWrapper {...rest} metadata={meta} />;
    }
}

export { FormInputFieldWrapper };
